<template>
  <section id="manifesto" class="section-shell manifesto-section" data-theme="grid">
    <div class="manifesto-card" data-reveal>
      <div class="spine"></div>
      <div class="spine spine-right"></div>
      <p>O mercado n&atilde;o &eacute; ca&oacute;tico. &Eacute; coreografado pelas institui&ccedil;&otilde;es &mdash; e a maioria nem percebe.</p>
      <p>A <span class="word-brand">ZIMA</span> nasceu para quem se recusa a ser figurante.</p>
      <p>Aqui, voc&ecirc; aprende a questionar o &oacute;bvio, interpretar inten&ccedil;&atilde;o, entender ciclos e antecipar movimentos.</p>
      <p>A Matrix te mant&eacute;m ocupado. A <span class="word-brand">ZIMA</span> te devolve clareza, vis&atilde;o e consci&ecirc;ncia.</p>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
.manifesto-section {
  padding: clamp(24px, 3.6vw, 34px);
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.manifesto-section,
.manifesto-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.manifesto-section::before {
  display: none !important;
}

.manifesto-card {
  border-radius: 16px;
  border: 1px solid rgba(115, 148, 240, 0.22);
  background: linear-gradient(165deg, rgba(11, 14, 24, 0.9), rgba(8, 10, 18, 0.92));
  padding: 16px 16px 16px 18px;
  display: grid;
  gap: 8px;
  position: relative;
  overflow: hidden;
}

.manifesto-card::before {
  content: '';
  position: absolute;
  inset: 0 12px auto;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(78, 115, 223, 0), rgba(118, 150, 240, 0.84) 22%, rgba(166, 118, 228, 0.8) 78%, rgba(155, 89, 182, 0));
}

.manifesto-card::after {
  content: '';
  position: absolute;
  inset: auto 12px 0;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(78, 115, 223, 0), rgba(118, 150, 240, 0.84) 22%, rgba(166, 118, 228, 0.8) 78%, rgba(155, 89, 182, 0));
}

.spine {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  border-radius: 16px 0 0 16px;
  background: linear-gradient(180deg, rgba(143, 187, 255, 0.95), rgba(190, 145, 255, 0.86));
  box-shadow: 0 0 10px rgba(115, 148, 240, 0.34);
}

.spine-right {
  left: auto;
  right: 0;
  border-radius: 0 16px 16px 0;
}

.manifesto-card p {
  margin: 0;
  color: #d1dbf0;
  line-height: 1.5;
  font-size: clamp(1.06rem, 1.14vw, 1.2rem);
  font-style: italic;
  position: relative;
  z-index: 1;
}

.word-brand {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

.manifesto-card .strong {
  font-weight: 700;
}

.manifesto-card .accent {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 2px 12px rgba(78, 115, 223, 0.35);
}

@keyframes zima-brand-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>

